<template>
  <div class="promotional">
      <div class="proWrapper">
        <div class="box_H5">
          
            <div class="ppTitle">{{$t('other.a406')}}</div>
            
            <div style="margin-top:20px;">
              <svg  class="icon01" aria-hidden="true">
                  <use xlink:href="#icon-weixinzhifu"></use>
              </svg>
              
            </div>
            <div class="scanCode">
              <img style="width:100%" :src="qrCode.qrCode" alt="">
            </div>
            <div style="font-size:14px;padding-bottom:10px;">{{$t('other.a149')}}-{{$t("other.a502")}}</div>
            <div style="font-size:25px;color:red">{{$t("other.a503")}}:￥999</div>

            <div class="tgkgo">
              <div class="inkg">
                <span>{{$t("other.a504")}}</span>
                <span>￥999/<span style="color:red;font-size:12px;">{{$t("other.a505")}}500</span></span>
              </div>
              <div class="inkg">
                <span>{{$t("other.a506")}}</span>
                <span>{{time}}</span>
              </div>
            </div>
        </div>
        <div class="box_pc">
          <div class="home">
            <el-button type="primary" @click="getLogin()">{{$t("other.a507")}}</el-button>
          </div>
          <div style="margin-top:20px;">
              <svg  class="icon01" aria-hidden="true">
                  <use xlink:href="#icon-weixinzhifu"></use>
              </svg>
              <!-- <svg  class="icon01" aria-hidden="true">
			  		   <use style="font-size: 30px;" xlink:href="#icon-zhifubao"></use>
			  	   </svg> -->
            </div>
            <div class="scanCode">
              <img style="width:100%" :src="qrCode.qrCode" alt="">
            </div>
            <div style="font-size:14px;padding-bottom:10px;">微信扫码付款</div>
            <div style="font-size:25px;color:red">{{$t("other.a503")}}:￥999</div>

            <div class="tipDesc">
              {{$t("other.a509")}}
            </div>
            <div class="kefu">
              <img src="@/assets/img/kefu3.png" alt="">
            </div>
            <div>{{$t("other.a510")}}</div>
        </div>

      </div>
  </div>
</template>

<script>
import order from '../api/moudles/order'
import utils from '@/utils/utils'
import api from '../api/moudles/shopaccess'

export default {
data(){
return{
    userId:null,
    qrCode:{

    }
}
},
created(){
  this.time=utils.getNowTime(0)
  this.getCodePay()
},
methods:{

  getLogin(){

    this.$router.push({
      path:'/loginPage'
    })
				 
				
                    // let  params={
                    // userId :this.$route.query.userId,
                    // token:this.$route.query.token,
                    
                    // }

                    // localStorage.setItem('userInfo',JSON.stringify(params))
					   
				   
		
					
					

                    // api
                    // .({userId:JSON.parse(localStorage.getItem('userInfo')).userId})
                    // .then(res => {
                    //     if(res.code === 200){
                    //         console.log('重新获取一次帐号的信息',res.data)
                           
                    //         let data=res.data
                    //         if(data.shopeeShops || data.lazadaShops || data.tiktokShops){
                    //             localStorage.setItem('shophasAuthorization', true)
                    //         }else{
                    //             localStorage.setItem('shophasAuthorization', false)
                    //         }
                    //         if(data.userPos=== 'STORE'){
                    //             localStorage.setItem('shophasAuthorization', true)
                                
                    //         }
                    //         localStorage.setItem('userInfo', JSON.stringify(data))
                    //         localStorage.setItem('shopIdInfo', JSON.stringify(data.shopeeShops))
                    //         localStorage.setItem('warehouse', JSON.stringify(data.stores))
                    //         localStorage.setItem('lazadashopId', JSON.stringify(data.lazadaShops))
                    //         this.showLoading()
                    //         setTimeout(()=> {
                              
                    //           setTimeout(()=> {
                    //           if(res.data.userPos == 'SELLER' && res.data.vipLevel == 0){
                    //             location.replace('/index')
                    //           }
                    //           if(res.data.userPos == 'STORE' && res.data.vipLevel == 0){
                    //             location.replace('/sellerManagement')
                    //           }
                    //           if(res.data.vipLevel == 1){
                    //             location.replace('/stockProduct/single')
                    //           }
                    //         },1000)
                            
                    //         },1000)
                    //     } 
                    // })
			
			},
  getCodePay(){

    order
		.createPayorderBywechat({
      rechargeId:13,
      token:this.$route.query.token,
      userId:this.$route.query.userId
    })
		.then(res => {
      console.log('res',res)

      this.qrCode=res.data
			// if(res.code === 200) {
			// 	console.log('微信二维码',res.data)
			// }else{
      //   this.$message.warning(res.msg)
      // }
		})
  }

}
}

</script>
<style lang="scss" scoped>

@media (min-width: 1200px){

  .promotional{
      width: 100%;
      height:100vh;
      background-color: #66ba65;
      position: relative;

      .proWrapper{
        width: 90%;
        height: 90vh;
        background-color: white;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        border-radius: 5px;
        box-sizing: border-box;
        padding: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .kefu{
          width: 80px;
          height: 80px;
          overflow: hidden;
          

          img{
            width: 100%;
          }
        }


        .box_H5{
          display: none;
        }

        .box_pc{
          display: flex;
          flex-direction: column;
          align-items: center;

          .home{
            position: absolute;
            left: 30px;
            top: 20px;
            color: #409EFF;
            font-weight: bold;
            font-size: 18px;
            cursor: pointer;
          }
        }

        .tipDesc{
          margin-top: 150px;
          color:#909399;
          margin-bottom: 10px;
        }
        

        .scanCode{
          width: 300px;
          height: 0;
          padding-bottom:300px;
          overflow: hidden;
          background-color: yellowgreen;
          margin: 10px 0;
          
        }

        
      }
    }
  

}

@media (max-width: 760px){
  .promotional{
      width: 100%;
      height:100vh;
      background-color: #66ba65;
      position: relative;

      .proWrapper{
        width: 90%;
        height: 90vh;
        background-color: white;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        border-radius: 5px;
        box-sizing: border-box;
        padding: 10px;
        display: flex;
        flex-direction: column;
      
        align-items: center;

        .box_pc{
          display: none;
        }

        .box_H5{
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .tgkgo{
          width: 100%;
          font-size: 16px;
          color: #909399;
          border-top: 2px dashed #909399;
          margin: 20px 0 15px 0;
        }

        .inkg{
          display: flex;
          justify-content: space-between;
          padding: 5px 0;
        }

        .ppTitle{
          width: 100%;
          text-align: center;
          padding: 10px 0;
          border-bottom: 2px dashed #909399;
          font-weight: bold;
        }

        .scanCode{
          width: 9rem;
          height: 0;
          padding-bottom:9rem;
          overflow: hidden;
          background-color: yellowgreen;
          margin: 10px 0;
          
        }
      }
    }
  
}

</style>